import { Component, Input, OnInit } from '@angular/core';
import { CampaignsFacadeService } from "@services/campaigns/campaigns-facade.service";
import { ContactHistoryFacadeService } from "@services/contactHistory/contactHistory-facade.service";
import { ContactHistoryCampaignModel, ContactHistoryModel } from '@models/index'
import { WorkflowModel } from "@models/workflow.model";
import { SentimentCheck } from "@enums/sentimentChek.enum";
import Swal from 'sweetalert2';
import { showSentimentCheck } from '@utilities/function-utils'

@Component({
  selector: 'contact-history',
  templateUrl: './contact-history.component.html',
  styleUrls: ['./contact-history.component.sass']
})

export class ContactHistoryComponent implements OnInit {
  @Input() contactHistory: ContactHistoryModel;
  @Input() contactId: string;
  @Input() created: number;

  campaign$ = this.campaignsFacadeService.getSelectedReviewRequestCampaign$();
  workflowCampaign: WorkflowModel;
  sentimentCheckEnum = SentimentCheck;
  selectedCampaigns: ('Email' | 'SMS')[] = ['Email'];
  
  constructor(
    private campaignsFacadeService: CampaignsFacadeService,
    private contactHistoryFacadeService: ContactHistoryFacadeService,
    private window: Window
  ) { }
  
  ngOnInit() {
    this.campaign$.subscribe(campaign => { 
      this.workflowCampaign = campaign.workflow;
    })
  }

  dateToString(eventDate: number) {
    const days = this.window.moment().diff(eventDate, 'days')
    return days < 7
      ? this.window.moment(eventDate).fromNow()
      : days === 7
        ? 'A week ago'
        : this.window.moment.unix(eventDate/1000).format('MM/DD/YY')
  }

  getSentimentCheckType(rating: number, type: string) {
    return `${type.slice(0, -1)}${type === SentimentCheck.Thumbs
      ? rating === 1 ? 'Up' : 'Down'
      : type === SentimentCheck.Faces
        ? rating === 1 ? 'Sad' : rating === 2 ? 'Neutral' : 'Happy'
        : ''
    }Icon`
  }

  restartCampaign(campaign: ContactHistoryCampaignModel) {
    Swal.fire({
      title: 'Restart Campaign',
      text: `Are you sure you want to restart campaign ${campaign.name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, restart it!',
      cancelButtonText: 'No, cancel'
    }).then(result => {
      if (result.value) {
        this.contactHistoryFacadeService.restartCampaignContactHistory(campaign.campaignId, this.contactId)
      }
    })
  }

  showSentimentCheckView(date: number): boolean {
    return showSentimentCheck(date)
  }
}
